import { getSession } from './globalHelper';
import { isChatMobileTabletDisable, isLoggedIn, isMobileLayout, isTabletLayout } from './twHelper';
import {
  initializeChatBot,
  setChatBotClickInSession,
  setChatCardClickInSession,
  wasChatBotClicked,
} from '../../js/lib/chat-bot-live-helper';
import * as AsyncHelper from '../../js/lib/asyncMessageHelper';
import { asyncOrigins } from '../../js/common/commonConstants';
import { getAsyncChatPillOCPParams } from '../../js/lib/omnichannelHelper';
import { generateLinkData, trackActivityEvent } from './analytics/fptiHelper';
import { chatBotFPTIs } from './analytics/contactUsPageAnalytics';

export const isChatCardClicked = () => getSession('chatCardClicked') === 'true';

export const disableChatbotInMobileTablet = () => (isMobileLayout() || isTabletLayout()) && isChatMobileTabletDisable();

export const hideChatBot = (display) => {
  return !display || disableChatbotInMobileTablet();
};

/*
 * if Chat Card never get clicked, then fire chatBotPromptContactUsShown fpti event
 * if Chat Card get clicked, then fire chatBotMessageBtnContactUsShown fpti event
 * */
export const handleChatBotPromptOrBtnShownFPTIEvent = ({ finalIntentRefId }) => {
  const chatBotFPTIEvent = isChatCardClicked()
    ? chatBotFPTIs.chatBotMessageBtnContactUsShown
    : chatBotFPTIs.chatBotPromptContactUsShown;
  const fptiData = {
    ...chatBotFPTIEvent,
    link: generateLinkData(chatBotFPTIEvent.link, { topicRefId: finalIntentRefId }),
  };
  trackActivityEvent(fptiData);
};

/**
 * this is to initiate the chatbot window
 * @param topicRefId
 * @param link
 * @param hpid
 * @param topicName
 * @param isChatBotAsyncUser
 * @param chatPillOcpParams
 * @returns {*}
 */
export const handleChatbotWindowOpen = ({ topicRefId, link, subject, isChatBotAsyncUser, chatPillOcpParams }) => {
  // Making chat card clicked true when user clicks on chatbot in both logout & login
  setChatCardClickInSession(true);

  if (!wasChatBotClicked() && !isLoggedIn()) {
    setChatBotClickInSession(true);
  }

  // NON ASYNC USER
  if (!isChatBotAsyncUser) {
    const chatBotParams = {
      topicRefId,
      link,
      subject,
    };

    // Launch ChatBot
    return initializeChatBot(chatBotParams);
  }

  // ASYNC USER without OCP intents
  if (!chatPillOcpParams)
    return AsyncHelper.initiateAsyncChat({
      topicRefId,
      subject,
      origin: asyncOrigins.CHAT_PILL,
    });

  // ASYNC USER with OCP intents
  // TODO: need to add SET_CONTEXT_INTENTS action somewhere; chatPillOcpParams = setContextIntents
  const ocpParamsForChatPill = getAsyncChatPillOCPParams(chatPillOcpParams);
  const customerIntent = ocpParamsForChatPill.customerIntent;
  const intentCode = ocpParamsForChatPill.intentCode;
  return AsyncHelper.initiateAsyncChat({
    topicRefId,
    customerIntent,
    intentCode,
    subject,
    origin: asyncOrigins.CHAT_PILL,
  });
};
